var ezdia;
(function (ezdia) {
    var _a = ezdia.config, COLLAPSE_GRID_WIDTH = _a.COLLAPSE_GRID_WIDTH, GRID_CHECKBOX_WIDTH = _a.GRID_CHECKBOX_WIDTH, GRID_BASE_COLUMN_WIDTH = _a.GRID_BASE_COLUMN_WIDTH;
    var pageParams = {};
    var footerSumArray = [];
    var TEMPLATE = ezdia.templates.grid;
    var STATUS_CSS_MAPPING = $.ezdia.config.STATUS_CSS_MAPPING;
    var loadingID = 'ez-sys-grid-item-loading';
    var defaultObj = {
        width: '100%',
        height: /MSIE/.test(navigator.userAgent) ? '' : 'auto',
        autowidth: true,
        shrinkToFit: false,
        loadtext: $.ezdia.loading.default(),
        searchFrm: '#searchFrm',
        rowList: [10, 20, 30, 50, 100, 200, 250, 400, 500],
        caption: ["<span id='gridCaption'></span>"],
        pager: '#footer',
        viewrecords: true,
        footerrow: false,
        columnChooser: true,
        refresh: true
    };
    var createGridwrapper = function (id, cls, gridContainer) {
        $("#" + gridContainer).html("<table class=\"" + cls + "\" id=\"" + id + "\"><tr><td></td></tr></table><div id=\"footer-" + id + "\"></div>");
    };
    var getHiddenTextarea = function (value) {
        if (value === void 0) { value = ''; }
        return "<textarea style=\"display: none\">" + value + "</textarea>";
    };
    var getDisplayText = function (content, cls) {
        if (content === void 0) { content = ''; }
        if (cls === void 0) { cls = ''; }
        return "<div class=\"col-max-height " + cls + "\">" + content + "</div>";
    };
    var getFormatter = function (value, content, cls) {
        if (value === void 0) { value = ''; }
        if (content === void 0) { content = ''; }
        var input = getHiddenTextarea(value);
        return input + getDisplayText(content, cls);
    };
    function eventSelectAllIds() {
        $('#ez-js-copy-field-btn').on('click', handelOnClickSelectAllIds);
    }
    function handelOnClickSelectAllIds() {
        $.ezdia.loading.show();
        var ids = ezdia.util.getAllItemIds();
        var idsValue = ids.join(',');
        $.ezdia.loading.hide();
        var copyText = $('#ez-js-copy-field').val(idsValue);
        copyText.select();
        document.execCommand('copy');
        ezdia.util.showSuccessError({
            message: 'Ids copied to clipboard'
        });
    }
    function getColumnWidth(gridContainerId, colModel, multiselect) {
        var e_1, _a;
        var gridContainer = document.getElementById(gridContainerId);
        if (!gridContainer) {
            return GRID_BASE_COLUMN_WIDTH;
        }
        var $gridContainer = $(gridContainer);
        var visibleCol = 0;
        var isMultiple = false;
        var multipleColWidth = COLLAPSE_GRID_WIDTH;
        var checkBoxWidth = 0;
        var menuWidth = 0;
        if (multiselect) {
            checkBoxWidth = GRID_CHECKBOX_WIDTH;
            multipleColWidth -= GRID_CHECKBOX_WIDTH;
        }
        try {
            for (var colModel_1 = __values(colModel), colModel_1_1 = colModel_1.next(); !colModel_1_1.done; colModel_1_1 = colModel_1.next()) {
                var col = colModel_1_1.value;
                var hidden = col.hidden, edittype = col.edittype;
                var isGridColumnHidden = ezdia.util.isGridColumnHidden(col);
                if (edittype === 'multiple') {
                    col.width = col.width || multipleColWidth + "px";
                    isMultiple = true;
                }
                else if (edittype === 'menu') {
                    menuWidth = 48;
                    col.width = menuWidth + "px";
                }
                else if (!hidden && !isGridColumnHidden) {
                    visibleCol += 1;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (colModel_1_1 && !colModel_1_1.done && (_a = colModel_1.return)) _a.call(colModel_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!isMultiple) {
            multipleColWidth = 0;
        }
        var outerWidth = $gridContainer.outerWidth() -
            checkBoxWidth -
            multipleColWidth -
            menuWidth -
            1;
        var colWidth = outerWidth / visibleCol;
        if (colWidth < GRID_BASE_COLUMN_WIDTH) {
            return GRID_BASE_COLUMN_WIDTH;
        }
        return colWidth;
    }
    function storeFieldValues(v, options) {
        var gid = options.gid, rowId = options.rowId, colName = options.colModel.name;
        var GRID_DATA = ezdia.config.GRID_DATA;
        GRID_DATA[gid] = GRID_DATA[gid] || {};
        GRID_DATA[gid][rowId] = GRID_DATA[gid][rowId] || {};
        GRID_DATA[gid][rowId][colName] = v;
    }
    function getMenu(_a) {
        var e_2, _b;
        var colModel = _a.colModel, rowId = _a.rowId;
        var menuItems = colModel.config.menuItems;
        var menuItemsli = [];
        try {
            for (var menuItems_1 = __values(menuItems), menuItems_1_1 = menuItems_1.next(); !menuItems_1_1.done; menuItems_1_1 = menuItems_1.next()) {
                var _c = menuItems_1_1.value, name_1 = _c.name, label = _c.label;
                menuItemsli.push("<li><a data-rowId=\"" + rowId + "\" data-link=\"" + name_1 + "\" href=\"javascript:void(0)\">" + label + "</a></li>");
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (menuItems_1_1 && !menuItems_1_1.done && (_b = menuItems_1.return)) _b.call(menuItems_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return "<a\n      data-menu=\"menu\"\n      href=\"javascript:void(0)\"\n      class=\"btn btn-circle btn-circle-sm ez-ellipsis-v-btn btn-transparent\">\n      <i class=\"fa fa-circle\"></i>\n      <i class=\"fa fa-circle\"></i>\n      <i class=\"fa fa-circle\"></i>\n    </a><ul class=\"dropdown-menu jqgrid-menu\">\n      " + menuItemsli.join('') + "\n    </ul>";
    }
    var columnFormatter = function (gridContainerId, colModel, multiselect, isDashboard) {
        pageParams = $.ezdia.config.pageParams;
        ezdia.config.GRID_EDITABLE_FIELDS[gridContainerId] = {};
        var colWidth = getColumnWidth(gridContainerId, colModel, multiselect);
        $.each(colModel || pageParams.colModel, function (i, column) {
            var name = column.composite ? -1 : column.name;
            column.config = $.ezdia.getFieldsConfig(column);
            if (column.edittype !== 'multiple' && column.edittype !== 'menu') {
                column.width = colWidth;
            }
            if (pageParams.fetchFields) {
                if ((column.config && column.config.disable_save) ||
                    column.edittype === 'comment') {
                    pageParams.fetchFields.push(-1);
                }
                else {
                    pageParams.fetchFields.push(name);
                }
            }
            // Comment because not in use anymore (need to check with rahul and neha before removing this code)
            if (column.edittype === 'table') {
                hasTableTypeField = true;
            }
            if (column.name === 'site_type') {
                column.formatter = function (v) {
                    var content = v;
                    if (pageParams.siteTypes) {
                        // eslint-disable-next-line consistent-return
                        $.each(pageParams.siteTypes, function (k, siteObj) {
                            if (k === v) {
                                content = siteObj.label;
                                return false;
                            }
                        });
                    }
                    return getFormatter(v, content);
                };
            }
            else if (pageParams.affiliatedBy !== 'ezdia' &&
                (column.name === 'writer_price' || column.name === 'editor_pay_status')) {
                column.formatter = function () { return '<div class="col-max-height"></div>'; };
            }
            else if (column.name === 'project_type') {
                column.formatter = function (v) {
                    var content = $.ezdia.grid.projectTypeView(v);
                    return getFormatter(v, content);
                };
            }
            else if (column.config && column.config.accountName) {
                column.formatter = function (v) {
                    var content = $.ezdia.grid.accountTypeView(v);
                    content = $(content).text();
                    return getFormatter(v, content);
                };
            }
            else if (column.config && column.config.gridEditable) {
                column.classes = (column.classes || '') + " editable-column";
                column.sortable = false;
                column.formatter = function (v, options) {
                    var colmodel = options.colModel, rowId = options.rowId;
                    var gridEditableFields = ezdia.config.GRID_EDITABLE_FIELDS[gridContainerId];
                    var col = $.extend(true, {}, colmodel);
                    col.id = ezdia.util.makeId();
                    col.rowId = rowId;
                    var content = $.ezdia.inputs.create({
                        column: col,
                        value: v
                    });
                    $.ezdia.widgets.init({ column: col }, gridContainerId);
                    if (!gridEditableFields[col.name]) {
                        gridEditableFields[col.name] = [];
                    }
                    gridEditableFields[col.name].push(col);
                    return getFormatter(v, content);
                };
            }
            else {
                switch (column.edittype) {
                    case 'date':
                        column.formatter = function (v, options) {
                            var content = $.ezdia.date.view(options.colModel.config, v);
                            return getFormatter(v, content);
                        };
                        break;
                    case 'group':
                        column.formatter = function (v, opt) {
                            var config = column.config;
                            var _a = config || {}, orglabels = _a.org_labels, options = _a.options;
                            if (orglabels && options) {
                                var content_1 = options[v] || v;
                                return getFormatter(v, content_1);
                            }
                            var content = $.ezdia.typehead.view(v, opt.colModel.config);
                            return getFormatter(v, content);
                        };
                        break;
                    case 'role':
                        column.formatter = function (v, options) {
                            var content = v;
                            if (options.colModel.config && options.colModel.config.url) {
                                content = $.ezdia.typehead.view(v, options.colModel.config);
                            }
                            return getFormatter(v, content);
                        };
                        break;
                    case 'url':
                        column.formatter = function (v) {
                            var content = buildUrlField('', v);
                            return getFormatter(v, content);
                        };
                        break;
                    case 'inputlist':
                        column.formatter = function (v, options) {
                            // var content = gridInputListDataFormatter(v, '');
                            var content = $.ezdia.listInput.view({
                                column: options.colModel,
                                value: v
                            });
                            return getFormatter(v, content);
                        };
                        break;
                    case 'tag':
                    case 'combo':
                        column.formatter = function (v, options) {
                            var content = $.ezdia.tagInput.view(options.colModel, v);
                            return getFormatter(v, content);
                        };
                        break;
                    case 'multichoice':
                        column.formatter = function (v, options) {
                            var content = $.ezdia.multichoice.view(v, options.colModel);
                            return getFormatter(v, content);
                        };
                        break;
                    case 'singlechoice':
                        column.formatter = function (v, options) {
                            var content = $.ezdia.singlechoice.view({
                                column: options.colModel,
                                value: v
                            });
                            return getFormatter(v, content, STATUS_CSS_MAPPING[v]);
                        };
                        break;
                    case 'select':
                        column.formatter = function (v, options) {
                            var content = $.ezdia.singlechoice.view({
                                column: options.colModel,
                                value: v
                            });
                            return getFormatter(v, content, STATUS_CSS_MAPPING[v]);
                        };
                        break;
                    case 'radio':
                        column.formatter = function (v) {
                            var content = $.ezdia.radio.view({
                                column: column,
                                value: v,
                                gridview: true
                            });
                            return getFormatter(v, content);
                        };
                        break;
                    case 'checkbox':
                        column.formatter = function (v) {
                            var content = $.ezdia.checkbox.view({
                                column: column,
                                value: v,
                                gridview: true
                            });
                            return getFormatter(v, content);
                        };
                        break;
                    case 'file':
                    case 'filetype':
                        column.formatter = function (v) {
                            var content = $.ezdia.upload.view({
                                value: v,
                                preview: true
                            });
                            return getFormatter(v, content);
                        };
                        break;
                    case 'multiple':
                        column.sortable = false;
                        column.formatter = function (v) {
                            return getFormatter(v, v);
                        };
                        break;
                    case 'menu':
                        column.hidden = false;
                        column.sortable = false;
                        column.formatter = function (v, options) {
                            return getMenu(options);
                        };
                        break;
                    default:
                        if (column.config && column.config.mouse_over) {
                            column.classes = (column.classes || '') + " editable-column ez-mouse-over-column";
                        }
                        column.formatter = function (v) {
                            var config = column.config;
                            var gridHtmlView = (config || {}).gridHtmlView;
                            var content = v;
                            if (typeof v !== 'number' && !gridHtmlView) {
                                content = $.ezdia.sanitizer.script(v);
                            }
                            if (typeof v !== 'number' && !gridHtmlView && !isDashboard) {
                                content = $.ezdia.sanitizer.html(content);
                            }
                            return getFormatter(v, content, STATUS_CSS_MAPPING[v]);
                        };
                        break;
                }
            }
            var formatter = column.formatter;
            column.formatter = function (v, options, rowData) {
                storeFieldValues(v, options);
                return formatter(v, options, rowData);
            };
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            column.unformat = function unformat(v, o, cell) {
                var _a;
                var rowId = o.rowId, colname = o.colModel.name;
                return ((_a = ezdia.config.GRID_DATA) === null || _a === void 0 ? void 0 : _a[this.id][rowId][colname]) || '';
            };
            var isGridColumnHidden = ezdia.util.isGridColumnHidden(column);
            if (isGridColumnHidden) {
                column.hidden = true;
            }
            column.title = false;
            if (column.config && column.config.sum) {
                defaultObj.footerrow = true;
                column.classes = 'text-right';
                footerSumArray.push(column.name);
            }
        });
    };
    var gridObj = {
        create: function (options) {
            var gridOptions = {};
            pageParams = $.ezdia.config.pageParams;
            options.gridContainerId = options.gridContainerId || 'gridContainer';
            options.id = options.id || 'grid';
            options.rowNum = options.rowNum || 10;
            options.pager = "#footer-" + options.id;
            ezdia.config.GRID_DATA[options.id] = {};
            var colModel = options.colModel;
            var id = options.id, classes = options.classes, multiselect = options.multiselect, customeBtnsWrapId = options.customeBtnsWrapId, gridContainerId = options.gridContainerId, isDashboard = options.isDashboard;
            createGridwrapper(id, classes, gridContainerId);
            $.ezdia.widgets.load(gridContainerId);
            columnFormatter(gridContainerId, colModel, multiselect, isDashboard);
            gridOptions = this.getOptions(options);
            $("#" + id)
                .on('jqGridLoadComplete', function (e, data) {
                $.ezdia.config.pageParams.jqGridRowsData = data;
                $.ezdia.config.GRID_RAW_DATA = data;
            })
                .jqGrid(gridOptions);
            if (!customeBtnsWrapId) {
                this.footer(gridOptions);
            }
        },
        getOptions: function (opt) {
            var _this = this;
            var options = $.extend(true, {}, opt);
            var loadCompleteFn = options.loadComplete;
            var onSelectRowFn = options.onSelectRow;
            var onSelectAllFn = options.onSelectAll;
            options.loadComplete = this.loadComplete.bind(this, loadCompleteFn, options);
            options.onSelectRow = function (rowid, clicked, event) {
                return _this.onSelectRow.call(_this, onSelectRowFn, options, rowid, clicked, event);
            };
            options.onSelectAll = function (rowid, clicked, event) {
                return _this.onSelectRow.call(_this, onSelectAllFn, options, rowid, clicked, event, true);
            };
            return $.extend(true, {}, defaultObj, options);
        },
        formatter: function (gridContainerId) {
            if (gridContainerId === void 0) { gridContainerId = 'gridContainer'; }
            columnFormatter(gridContainerId);
        },
        getColumnWidth: function (gridContainerId, col) {
            if (gridContainerId === void 0) { gridContainerId = 'gridContainer'; }
            var colModel = col || $.ezdia.config.pageParams.colModel;
            return getColumnWidth(gridContainerId, colModel);
        },
        renderGridActionsBtns: function (gridOptions) {
            var _a = $.ezdia.config.pageParams, assignmentList = _a.assignmentList, tab = _a.tab;
            var actionItems = ezdia.component.quickActions.actionItems;
            var id = gridOptions.id, customeBtnsWrapId = gridOptions.customeBtnsWrapId, isExport = gridOptions.isExport, columnChooser = gridOptions.columnChooser;
            var exportRole = pageParams.exportRole, userManagement = pageParams.userManagement, hasCreateAccountRole = pageParams.hasCreateAccountRole, hasEditFieldsRole = pageParams.hasEditFieldsRole;
            // tslint:disable-next-line:no-shadowed-variable
            var grid = $("#" + id);
            var gridBtns = [
                {
                    icon: 'fa-refresh',
                    id: 'ez-js-grid-action-refresh',
                    title: 'Reload',
                    cls: 'reload',
                    onClickButton: function () {
                        $.ezdia.desk.grid.resetGridWidthAndForm(true);
                        grid.trigger('reloadGrid');
                    }
                }
            ];
            grid.jqGrid('navGrid', "#footer-" + id, {
                refresh: false,
                add: false,
                edit: false,
                del: false,
                search: false
            });
            if (columnChooser) {
                gridBtns.push({
                    icon: 'fa-filter',
                    id: 'chooseColumns_grid',
                    title: 'Choose Columns',
                    onClickButton: function (e) {
                        e.stopPropagation();
                        grid.jqGrid('columnChooser');
                    }
                });
            }
            if (exportRole || isExport) {
                var exportFn_1 = gridOptions.exportFn ||
                    function exportFn(event) {
                        var element = $(event.currentTarget);
                        var frmID = grid.jqGrid('getGridParam', 'searchFrm');
                        $(frmID).search('export', element, event);
                    };
                gridBtns.push({
                    icon: 'fa-download',
                    title: 'Export Data',
                    id: 'columnExport_grid',
                    onClickButton: function (e) {
                        e.stopPropagation();
                        exportFn_1(e);
                    }
                });
            }
            if (pageParams.import && !userManagement) {
                var importFn = gridOptions.importFn ||
                    function importFn(e) {
                        e.stopPropagation();
                        grid.jqGrid('columnImport');
                    };
                gridBtns.push({
                    icon: 'fa-upload',
                    title: 'Import',
                    id: 'columnImport_grid',
                    onClickButton: importFn
                });
            }
            if (hasCreateAccountRole && userManagement) {
                gridBtns.push({
                    icon: 'fa-user-plus',
                    title: 'New User',
                    id: 'ez-js-grid-action-new-user',
                    onClickButton: function () {
                        window.location.href = pageParams.CONTEXT_ROOT + "/desk/CreateUserForm.htm";
                    }
                });
            }
            if (hasEditFieldsRole) {
                gridBtns.push({
                    id: 'ez-js-grid-action-edit-form',
                    icon: 'fa-pencil',
                    title: 'Configure form',
                    onClickButton: function () {
                        $.ezdia.desk.grid.resetGridWidthAndForm();
                        $.ezdia.formConfiguration.render(true);
                    }
                });
            }
            gridBtns.push({
                id: 'ez-js-form-disable-split-view',
                icon: 'fa-angle-double-left',
                title: 'Hide grid view',
                cls: 'btn-disable-split-view',
                onClickButton: function () {
                    ezdia.component.form.toggleFullView();
                }
            });
            var btns = TEMPLATE.actionBtnsGroup(gridBtns);
            var btnsWrapper = $("#" + customeBtnsWrapId);
            btnsWrapper.html(btns);
            // eslint-disable-next-line array-callback-return
            gridBtns.map(function (btn) {
                // eslint-disable-next-line no-unused-expressions
                btn.onClickButton && $("#" + btn.id).on('click', btn.onClickButton);
            });
            if (actionItems && Object.keys(actionItems).length !== 0) {
                ezdia.component.quickActions.renderShadowLinks(btnsWrapper);
            }
            if (assignmentList && assignmentList.length) {
                ezdia.component.quickActions.renderAssignmentList(btnsWrapper);
            }
            if (tab === 'MyOpenTask') {
                ezdia.component.quickActions.checkoutBtn(btnsWrapper);
            }
        },
        footer: function (gridOptions) {
            var columnChooser = gridOptions.columnChooser, refresh = gridOptions.refresh;
            var footerID = "#footer-" + gridOptions.id;
            // tslint:disable-next-line:no-shadowed-variable
            var grid = $("#" + gridOptions.id);
            grid.jqGrid('navGrid', footerID, {
                add: false,
                edit: false,
                del: false,
                search: false,
                refresh: refresh
            });
            if (columnChooser) {
                grid.jqGrid('navButtonAdd', footerID, {
                    caption: '',
                    buttonicon: 'glyphicon-filter',
                    id: 'chooseColumns_grid',
                    title: 'Choose Columns',
                    onClickButton: function () {
                        $(this).jqGrid('columnChooser');
                    }
                });
            }
            if (pageParams.exportRole || gridOptions.isExport) {
                var exportFn = gridOptions.exportFn ||
                    function exportFn(event) {
                        var element = $(event.currentTarget);
                        var frmID = $(this).jqGrid('getGridParam', 'searchFrm');
                        $(frmID).search('export', element, event);
                    };
                $('#grid').jqGrid('navButtonAdd', footerID, {
                    caption: '',
                    buttonicon: 'glyphicon-download-alt',
                    title: 'Export Data',
                    id: 'columnExport_grid',
                    onClickButton: exportFn
                });
            }
            if (pageParams.import && !pageParams.userManagement) {
                var importFn = gridOptions.importFn ||
                    function importFn() {
                        $(this).jqGrid('columnImport');
                    };
                $('#grid').jqGrid('navButtonAdd', footerID, {
                    caption: '',
                    buttonicon: 'fa fa-upload',
                    title: 'Import',
                    id: 'columnImport_grid',
                    onClickButton: importFn
                });
            }
            if (pageParams.hasCreateAccountRole && pageParams.userManagement) {
                $('#grid').jqGrid('navButtonAdd', footerID, {
                    caption: '',
                    buttonicon: 'fa fa-user-plus',
                    title: 'New User',
                    onClickButton: function () {
                        window.location.href = pageParams.CONTEXT_ROOT + "/desk/CreateUserForm.htm";
                    }
                });
            }
            if (pageParams.hasEditFieldsRole) {
                $('#grid').jqGrid('navButtonAdd', footerID, {
                    caption: '',
                    buttonicon: 'fa fa-pencil',
                    title: 'Configure form',
                    onClickButton: function () {
                        $.ezdia.formConfiguration.render();
                    }
                });
            }
        },
        footerSum: function () {
            var self = $(this);
            $.each(footerSumArray, function (i, colName) {
                var total = self.jqGrid('getCol', colName, false);
                var obj = {};
                obj[colName] = total.length
                    ? total.reduce(function (sum, x) { return +sum + +x; })
                    : 0;
                self.jqGrid('footerData', 'set', obj);
            });
        },
        loadComplete: function (loadCompleteFn, options) {
            var gridContainerId = options.gridContainerId, menu = options.menu, id = options.id;
            $.ezdia.widgets.create(gridContainerId);
            // tslint:disable-next-line:no-shadowed-variable
            var grid = $("#" + options.id);
            if (loadCompleteFn) {
                loadCompleteFn.call(grid);
            }
            if (footerSumArray) {
                this.footerSum.call(grid);
            }
            if (options.customeBtnsWrapId) {
                this.renderGridActionsBtns(grid.jqGrid('getGridParam'));
            }
            if (menu) {
                this.menuactions(id);
            }
        },
        menuactions: function (id) {
            var grid = $("#" + id);
            var colModel = grid.jqGrid('getGridParam', 'colModel');
            var menuColumn = __spread(colModel).pop();
            var menuItems = menuColumn.config.menuItems;
            grid.find("[data-menu=\"menu\"]").on('click', this.handelMenuOnClick);
            grid
                .find(".jqgrid-menu a[data-rowid]")
                .on('click', this.handelMenuItemOnClick.bind(this, menuItems, id));
        },
        handelMenuOnClick: function (event) {
            event.stopPropagation();
            var element = $(this);
            var menu = element.next();
            var doc = $(document);
            var scrollTop = doc.scrollTop();
            var _a = element.offset(), top = _a.top, left = _a.left;
            menu.show().css({
                top: top - scrollTop,
                left: left - menu.outerWidth()
            });
            var coverId = ezdia.util.makeId();
            $('body').append("<div id=\"" + coverId + "\" class=\"jqgrid-menu-cover\"></div>");
            doc.on('scroll.ez.jqgridmenu', function () {
                menu.show().css({
                    top: top - doc.scrollTop()
                });
            });
            doc.on('click.ez.jqgridmenu', function () {
                doc.off('click.ez.jqgridmenu').off('scroll.ez.jqgridmenu');
                menu.hide();
                $("#" + coverId).remove();
            });
        },
        handelMenuItemOnClick: function (menuOptions, gridId, event) {
            var currentTarget = event.currentTarget;
            var dataset = currentTarget.dataset;
            var rowid = dataset.rowid, link = dataset.link;
            var _a = __read(menuOptions.filter(function (_a) {
                var name = _a.name;
                return link === name;
            }), 1), options = _a[0];
            switch (link) {
                case 'inactive':
                    ezdia.pages.ezAnalyticsAlerts.markStatus(rowid, options, gridId);
                    break;
                case 'edit':
                case 'duplicate':
                    ezdia.pages.ezAnalyticsAlerts.craeteAlertWithData(rowid, options, gridId);
                    break;
                default:
                    break;
            }
        },
        onSelectRow: function (callback, options, rowid, clicked, event, isSelectAll) {
            var grid = $("#" + options.id);
            var formActive = grid.getGridParam('formActive');
            var isCBClick = false;
            if (event) {
                isCBClick = ezdia.util.gridCBClick(event);
                if (!formActive && isCBClick) {
                    return;
                }
            }
            var deselectInprogress = ezdia.component.quickActions.deselectInprogress;
            if (deselectInprogress) {
                return;
            }
            var isQuickActionSelected = ezdia.component.quickActions.isQuickActionSelected();
            var selectedIdsCount = ezdia.util.getSelectedGridItemsByGridId().length;
            if (selectedIdsCount && isCBClick && isQuickActionSelected) {
                // if (isQuickActionSelected) {
                var retVal = ezdia.component.quickActions.validateItemsLimitOnGridSelect(options.id, rowid, event);
                if (retVal) {
                    setTimeout(function () {
                        ezdia.component.quickActions.updateWithNewSelection(options.id, rowid, clicked);
                    }, 0);
                }
                else {
                    ezdia.component.quickActions.deselctRows(rowid, isSelectAll);
                }
            }
            else {
                callback.call(grid, rowid, clicked, event);
            }
        },
        // tslint:disable-next-line:no-shadowed-variable
        selectFirstItem: function (grid) {
            pageParams = $.ezdia.config.pageParams;
            var elem = grid instanceof jQuery ? grid : $(grid);
            var id = elem.getDataIDs()[0];
            if (id) {
                elem.jqGrid('setSelection', id, true);
            }
            delete pageParams.sysSelectFirst;
        },
        quickAction: function (id) {
            pageParams = $.ezdia.config.pageParams;
            var action = $.ezdia.sanitizer.specialChar(pageParams.sysQuickAction);
            var ids = $("#" + id).getDataIDs()[0];
            var elem = null;
            if (!ids && !ids.length) {
                return;
            }
            $('#selectAll').trigger('click');
            elem = $("a[data-type=\"" + action.trim() + "\"]");
            if (elem.length) {
                elem.trigger('click');
            }
            delete pageParams.sysQuickAction;
        },
        projectTypeView: function (v) {
            var mapping = $.ezdia.config.PROJECT_TYPE_CSS_MAPPING;
            var cls = "label " + (mapping[v] || 'label-default');
            var label = '';
            if (v) {
                label = "<span class=\"" + cls + "\">" + v + "</span>";
            }
            return label;
        },
        accountTypeView: function (v) {
            var allProjects = $.ezdia.config.pageParams.allProjects || {};
            var label = v;
            var projects = ezdia.util.jsonParse(allProjects);
            $.each(projects, function (key, accounts) {
                // eslint-disable-next-line consistent-return
                $.each(accounts, function (accName, accLabel) {
                    if (accName === v) {
                        label = accLabel;
                        return false;
                    }
                });
            });
            return "<div class=\"col-max-height\" data-value=\"" + v + "\">" + label + "</div>";
        },
        loading: {
            create: function () {
                if ($("#" + loadingID).length) {
                    return;
                }
                var template = "\n          <div id=\"" + loadingID + "\" class=\"ez-loading-body\">\n            <span><i class=\"fa fa-spinner fa-4x fa-pulse fa-fw\"></i>\n          </div>";
                $('body').append(template);
            },
            show: function () {
                this.create();
                $('body').addClass('show-loading').css({
                    overflow: 'hidden'
                });
            },
            hide: function () {
                $('body').removeClass('show-loading').css({
                    overflow: ''
                });
            }
        },
        isRowSelected: function (msg) {
            if (msg === void 0) { msg = 'Please select at least one item'; }
            var selectAll = $('#selectAll').is(':checked');
            var selIds = selectAll ? getAllItemIds() : getGridSelRow();
            var returnVal = selIds;
            if (!selIds.length) {
                var wrapper = $.ezdia.getWrapper('ez-js-sys-grid-item-selected');
                wrapper.html(msg).dialog({
                    modal: true,
                    title: 'No item selected',
                    width: 400,
                    height: 200,
                    buttons: [
                        {
                            text: 'Close',
                            class: 'btn-link',
                            click: function () {
                                $(this).dialog('close');
                            }
                        }
                    ]
                });
                returnVal = false;
            }
            return returnVal;
        },
        onSelectAllClick: function (event) {
            var _a = (event || {}).target, target = _a === void 0 ? {} : _a;
            var checked = target.checked;
            var gridContaner = $("[id^=gbox_]");
            var infoWrap = $('#ez-js-form-item-info');
            var isShow = ezdia.component.form.isShow;
            var gridCheckBox = $('#cb_grid').prop('checked', checked);
            var gridRowCheckBox = $('input:checkbox[name^=jqg_grid_]').prop('checked', checked);
            if (checked) {
                $.ezdia.quickLinks.triggersOn('#ez-quick-action-links');
                gridContaner.addClass('ez-grid-select-all');
                gridCheckBox.attr('disabled', 'disabled');
                gridRowCheckBox.attr('disabled', 'disabled');
                if (!isShow) {
                    ezdia.component.form.show();
                }
                if (infoWrap.length) {
                    var btn = TEMPLATE.allSelectedIdsBtn({});
                    infoWrap.html("<b class=\"text-info\">All Items are Selected.</b>" + btn);
                    eventSelectAllIds();
                }
            }
            else {
                $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
                gridContaner.removeClass('ez-grid-select-all');
                gridCheckBox.removeAttr('disabled');
                gridRowCheckBox.removeAttr('disabled');
                hideShowDeskForm('');
                if (infoWrap.length) {
                    infoWrap.html('');
                }
                $('#grid').jqGrid('resetSelection');
                ezdia.component.form.hide();
            }
        }
    };
    var component;
    (function (component) {
        component.grid = gridObj;
    })(component = ezdia.component || (ezdia.component = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.grid = gridObj;
})(ezdia || (ezdia = {}));
// eslint-disable-next-line no-redeclare
(function (ezdia) {
    $.jgrid.extend({
        columnChooser: function () {
            var colModel = this.jqGrid('getGridParam', 'colModel');
            var id = $(this).attr('id');
            var selAll = true;
            var self = this;
            // eslint-disable-next-line consistent-return
            $.each(colModel, function (i, o) {
                if (o.hidden) {
                    selAll = false;
                    return false;
                }
            });
            var content = {
                selectAll: selAll,
                colList: colModel
            };
            var popup = $("#chooseColumns_" + id).popupList({
                content: content,
                placement: function (context) {
                    $(context)
                        .on('click', function (e) {
                        e.stopPropagation();
                    })
                        .multiItemCheckList({
                        callback: clickOnItem
                    });
                    return 'auto';
                },
                buttons: {
                    Reset: function () {
                        return __awaiter(this, void 0, void 0, function () {
                            var settingData, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        settingData = ezdia.util.getUserSettingData({
                                            action: 'choosecolumn',
                                            queryName: id
                                        });
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, ezdia.util.clearUserSettings(settingData)];
                                    case 2:
                                        _a.sent();
                                        popup.popupList('destroy');
                                        window.location.reload();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_1 = _a.sent();
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        });
                    },
                    Save: function () {
                        var chosenColumns = [];
                        $('[data-column="choose"]').each(function each() {
                            var _a = this, name = _a.name, checked = _a.checked;
                            if (checked) {
                                self.jqGrid('showCol', name);
                                chosenColumns.push(name);
                            }
                            else {
                                self.jqGrid('hideCol', name);
                            }
                        });
                        var settingData = ezdia.util.getUserSettingData({
                            action: 'choosecolumn',
                            queryName: id,
                            columnValue: chosenColumns.join(',')
                        });
                        ezdia.util.saveUserSettings(settingData);
                        popup.popupList('destroy');
                    }
                }
            });
            $('body')
                .off('.columnChooserBodyClick')
                .on('click.columnChooserBodyClick', function click() {
                popup.popupList('destroy');
                $(this).off('.columnChooserBodyClick');
            });
            function clickOnItem(elem, name) {
                var e_3, _a;
                var $elem = $(elem);
                var isChecked = $elem.is(':checked');
                var colActionType = isChecked ? 'showCol' : 'hideCol';
                var pageParams = $.ezdia.config.pageParams || [];
                var index = $elem.closest('li').data('index');
                if (name === 'all') {
                    try {
                        for (var _b = __values(pageParams.colModel), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var column = _c.value;
                            self.jqGrid(colActionType, column.name);
                            column.hidden = !isChecked;
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
                else {
                    if (pageParams.colModel[index]) {
                        pageParams.colModel[index].hidden = !isChecked;
                    }
                    self.jqGrid(colActionType, name);
                }
            }
        },
        columnImport: function () {
            var id = $(this).attr('id');
            var popup = $("#columnImport_" + id).popupList({
                content: '',
                template: 'grid-import-menu-wrapper',
                itemTemplate: 'grid-import-menu',
                placement: function (context) {
                    $(context).on('click', function (e) {
                        e.stopPropagation();
                    });
                    return 'auto';
                }
            });
            $('body')
                .off('.columnChooserBodyClick')
                .on('click.columnChooserBodyClick', function click() {
                popup.popupList('destroy');
                $(this).off('.columnChooserBodyClick');
            });
        },
        columnExport: function () {
            var id = "#columnExport_" + $(this).attr('id');
            callExportData(id);
        }
    });
})(ezdia || (ezdia = {}));
